import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:'filterAG'
})

export class FilterPipeAlumGrp implements PipeTransform {

    transform(value:any,arg:any):any{

        const resultPosts=[];

        for(const alumno of value){

            if(alumno.nombre.toLowerCase().indexOf(arg.toLowerCase())  > -1){
                resultPosts.push(alumno);
            }
            else if(alumno.matricula.toLowerCase().indexOf(arg.toLowerCase())  > -1){
                  resultPosts.push(alumno);
              }
        };

        return resultPosts;

    }


}